import React from 'react';
import { useState, forwardRef } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Popover,
  Tooltip
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router';

interface IContextMenuPopoverProps {
  index: number;
  navigateLink: string;
}

const ContextMenuPopover = forwardRef((props: IContextMenuPopoverProps, _ref) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.preventDefault()
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Tooltip title="View" placement="top" > 
        <VisibilityIcon
          id="btn-project-edit-view=true"
          onContextMenu={handleClick}
          onClick={(event) => {
            if (event.ctrlKey || event.button === 1) {
              window.open(props?.navigateLink, "_blank");
            } else if (event.type === 'click') {
              navigate(props?.navigateLink);
            }
          }}
          style={{
            fontSize: '17px',
            cursor: 'pointer'
          }}
        />
      </Tooltip>
      <Popover
        className="more-vert-popover"
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
      >
        <Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
          <nav aria-label="main mailbox folders">
            <List>
              <ListItem disablePadding>
              <ListItemButton onClick={() => {
                handleClose();
                window.open(props?.navigateLink, "_blank");
              }}>
                <ListItemText primary="Open new tab" />
              </ListItemButton>
            </ListItem>
            </List>
          </nav>
        </Box>
      </Popover>
    </div>
  );
});

export default ContextMenuPopover;
